@if (subscription) {
  <div>
    @if (isOne && workflowStep === 'select-next-subscription-cancel-period') {
      <app-subscription-one-cancel-period
        [subscription]="subscription"
        (selectCancelPeriodEvent)="onCancelPeriodSelected($event)"
        (backEvent)="resetWorkflowAndRedirect()"
      ></app-subscription-one-cancel-period>
    }
    @if (workflowStep === 'confirm-subscription-cancel') {
      <app-subscription-cancel-confirm
        [subscription]="subscription"
        [isSubscriptionCancellingNow]="isSubscriptionCancellingNow"
        (confirmCancelEvent)="onCancelConfirmed($event)"
        (backEvent)="resetWorkflowAndRedirect()"
      ></app-subscription-cancel-confirm>
    }
    @if (workflowStep === 'partner-cancel-subscription-done') {
      <app-buy-thankyou-partner
        [orderName]="saleOrder.name">
      </app-buy-thankyou-partner>
    }
  </div>
}
